import React from 'react'
import { SiteLangs } from '../types/enums';
import { I18NContext } from '../i18n/i18nprovider';

export type LangPickerProps = {};

const LangPicker: React.FC<LangPickerProps> = () => {
  const { lang, changeLang } = React.useContext(I18NContext);

  return (
    <select value={lang} onChange={(e) => {changeLang(e.target.value as SiteLangs)}}>
      <option value={SiteLangs.EN}>English</option>
      <option value={SiteLangs.ES}>Spanish</option>
      <option value={SiteLangs.ZH}>Chinese</option>
      <option value={SiteLangs.PT}>Portuguese</option>
    </select>
  );
}

export default LangPicker;